module.exports = __webpack_public_path__ + "img/service_img3.336982aa.png";